// The EquaOS design system for this app. Components are the vendored source
// (vendor/, exact copies, checked by ds.test.js), compiled by this app's own
// build. Import from here, not from vendor/ directly.
import './poppins.css';
import './equaos.scoped.css';
import './dps-legacy.scoped.css';
// The legacy screens' DPS variables, re-pointed at EquaOS (29 Oct 2026).
import './equaos-legacy.css';
import './frame.css';
import { defineIconifyShim } from './iconify-shim';

// AppShell and Assistant draw icons with <iconify-icon>; serve them locally.
defineIconifyShim();

export { Assistant } from './vendor/components/agent/Assistant.jsx';
export { Logo } from './vendor/components/brand/Logo.jsx';
export { TenantWatermark } from './vendor/components/brand/TenantWatermark.jsx';
export { Card, CardHeader } from './vendor/components/data/Card.jsx';
export { StatusPill } from './vendor/components/data/StatusPill.jsx';
export { Table } from './vendor/components/data/Table.jsx';
export { Tabs } from './vendor/components/data/Tabs.jsx';
export { EmptyState } from './vendor/components/feedback/EmptyState.jsx';
export { Modal } from './vendor/components/feedback/Modal.jsx';
export { Toast } from './vendor/components/feedback/Toast.jsx';
export { Button } from './vendor/components/forms/Button.jsx';
export { Checkbox } from './vendor/components/forms/Checkbox.jsx';
export { FormField } from './vendor/components/forms/FormField.jsx';
export { Input } from './vendor/components/forms/Input.jsx';
export { Radio } from './vendor/components/forms/Radio.jsx';
export { Select } from './vendor/components/forms/Select.jsx';
export { Switch } from './vendor/components/forms/Switch.jsx';
export { AppShell } from './vendor/components/navigation/AppShell.jsx';
export { Breadcrumb } from './vendor/components/navigation/Breadcrumb.jsx';
export { Sidebar } from './vendor/components/navigation/Sidebar.jsx';
export { MODULE_GROUPS, STATUS_TONE, STATUS_LABEL } from './vendor/guidelines/moduleMap.js';
export { Icon } from './icons.jsx';
export { ShellLayoutContext, useShellLayout } from './layout';
